import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Collapse, CollapseProvider, CollapseToggle, CollapseTrigger, Separator } from 'telia-front-react';
import InternetCalculatorStore from '../../stores/InternetCalculatorStore';
import SuggestInternetSpeed from './SuggestInternetSpeed';
import { TranslationsContext } from '@teliaee/telia-translate';

interface Props {
  calculatorKey: string;
  internetCalculatorStore?: InternetCalculatorStore;
}

const SuggestInternetSpeedRow = (props: Props): JSX.Element => {
  const translate = React.useContext(TranslationsContext).translate;
  const { internetCalculatorStore, calculatorKey } = props;
  const state = internetCalculatorStore.getState(calculatorKey);
  const b2bSuffix = state.propState.segment === 'BUSINESS' ? '.B2B' : '';
  return (
    <div className="text" id={`${calculatorKey}-result-card`}>
      {internetCalculatorStore.hasSuggestibleInternets(calculatorKey) && (
        <AnalyticsTrigger trigger={{ id: 'Link - Need help', callback: 'onToggle' }}>
          <CollapseProvider id="internetAndTvCalculatorSuggestSpeed">
            <CollapseTrigger>
              <CollapseToggle text={translate('internetAndTvCalculator.needSpeedHelp')} iconRight="#arrow-down" link={true} />
            </CollapseTrigger>
            <Collapse color="grey">
              <SuggestInternetSpeed
                key={internetCalculatorStore.getState(calculatorKey).address.id}
                addressId={internetCalculatorStore.getState(calculatorKey).address.id}
                internetSpeeds={internetCalculatorStore.getSuggestibleInternets(calculatorKey)}
                suggestSpeed={state.propState.suggestSpeed}
                calculatorKey={calculatorKey}
                segment={state.propState.segment}
                b2bSuffix={b2bSuffix}
              />
            </Collapse>
          </CollapseProvider>
        </AnalyticsTrigger>
      )}
      <Separator spacing="xsmall" color="invisible" />
    </div>
  );
};

export default inject('internetCalculatorStore')(observer(SuggestInternetSpeedRow));
